var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-0 drag-column"},[_c('div',{staticClass:"pool-card"},[_c('div',{staticClass:"column-padding"},[_c('h4',{staticClass:"card-title mb-3 pb-1 border-bottom"},[_vm._v(_vm._s(_vm.heading))])]),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }